module.exports = __webpack_public_path__ + "img/ic24Invoice.371a0977.svg";